import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Upload } from "lucide-react";
import { Profile } from "@/hooks/useProfile";

interface ProfileAvatarProps {
  profile: Profile;
  isOwnProfile: boolean;
  onUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ProfileAvatar = ({ profile, isOwnProfile, onUpload }: ProfileAvatarProps) => {
  return (
    <div className="relative group">
      <Avatar className="h-32 w-32 border-4 border-flux-black">
        <AvatarImage src={profile.avatar_url || "/placeholder.svg"} />
        <AvatarFallback>{profile.full_name?.charAt(0) || "?"}</AvatarFallback>
      </Avatar>
      {isOwnProfile && (
        <label className="absolute inset-0 flex items-center justify-center bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity rounded-full cursor-pointer">
          <input
            type="file"
            accept="image/*"
            onChange={onUpload}
            className="hidden"
          />
          <Upload className="w-6 h-6 text-white" />
        </label>
      )}
    </div>
  );
};